import {SystemAgentUser, SystemAgentDomain} from "../Types";
import {CURRENT_REGION} from "../utils/region";
import jsonApi from "./jsonApi";

export async function list(domain: SystemAgentDomain) {
  return await jsonApi.get<SystemAgentUser[]>(`/region/${CURRENT_REGION}/api/system_agents/${domain}`);
}
